import {request} from "@/util/request";

export function GetLeaveList(params) {
    return request({
        url: '/Leave.asmx/GetLeaveList',
        method: 'GET',
        params
    })
}

export function GetLeaveInfo(params) {
    return request({
        url: '/Leave.asmx/GetLeaveInfo',
        method: 'GET',
        params
    })
}

export function doAdd(params) {
    return request({
        url: '/Leave.asmx/AddLeave',
        method: 'GET',
        params
    })
}

export function GetLeaveAddInfo(params) {
    return request({
        url: '/Leave.asmx/GetLeaveAddInfo',
        method: 'GET',
        params
    })
}

export function GetLeaveADTInfo(params) {
    return request({
        url: '/Leave.asmx/GetLeaveADTInfo',
        method: 'GET',
        params
    })
}

export function LeaveADTSP(params) {
    return request({
        url: '/Leave.asmx/LeaveADTSP',
        method: 'GET',
        params
    })
}

export function LeaveConfirm(params) {
    return request({
        url: '/Leave.asmx/LeaveConfirm',
        method: 'GET',
        params
    })
}

export function LeaveReg(params) {
    return request({
        url: '/Leave.asmx/LeaveReg',
        method: 'GET',
        params
    })
}


export function LeaveADTInfo(params) {
    return request({
        url: '/Leave.asmx/LeaveADTInfo',
        method: 'GET',
        params
    })
}


